import { Box, Grid, IconButton, Button, Tooltip } from "@mui/material";
import React from "react";
import ApiEndpoints from "../network/ApiEndPoints";
import { useState } from "react";
import { CustomStyles } from "../component/CustomStyle";
import { currencySetter, numberSetter } from "../utils/Currencyutil";

import CachedIcon from "@mui/icons-material/Cached";

import { dateToTime, ddmmyy } from "../utils/DateUtils";

import ApiPaginate from "../component/ApiPaginate";


import UpdatePgScheme from "./UpdatePgScheme";
import AddPgModel from "./AddPgModel";

let refresh;
function refreshFunc(setQueryParams) {
  setQueryParams("");
  if (refresh) refresh();
}
const AdminPgSchema = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState();

  const columns = [
    {
      name: "Created At",
      selector: (row) => (
        <div className="mb-1">
          {ddmmyy(row.created_at)}
          <br />
          {dateToTime(row.created_at)}
        </div>
      ),
      width: "100px",
    },
    {
      name: "ID",
      selector: (row) => <div className="blue-highlight-txt">{row.id}</div>,
    },
    {
      name: "Name",
      selector: (row) => <div>{row.name}</div>,
    },
    {
      name: "Slab1",
      selector: (row) => currencySetter(row.slab1),
    },

    {
      name: "Ad comm",
      selector: (row) => currencySetter(row.ad_comm || "NA"),
    },
    {
      name: "Md comm",
      selector: (row) => currencySetter(row.md_comm),
    },
    {
      name: "Status",
      selector: (row) => (
        <Box sx={{ display: "flex" }}>
          {row.status === 1 ? (
            <Button
              size="small"
              sx={{
                backgroundColor: "#399918",
                padding: "8px",
                fontSize: "12px",
                color: "#ffffff",
                fontWeight: "700",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#7CB342",
                  color: "#ffffff",
                },
              }}
            >
              Active
            </Button>
          ) : (
            <Button
              size="small"
              sx={{
                backgroundColor: "#FDA403",
                padding: "8px",
                fontSize: "12px",
                color: "#ffffff",
                fontWeight: "700",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#EB8317",
                  color: "#ffffff",
                },
              }}
            >
              InActive
            </Button>
          )}
          {/* <AdminBanksDetailsModal row={row} /> */}
        </Box>
      ),
    },

    {
      name: <span className="mx-4">Actions</span>,
      selector: (row) => <UpdatePgScheme row={row} refresh={refresh} />,
      center: true,
    },
  ];

  return (
    <Box>
      <Box
        sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}
      >
        <Box sx={{ mr: 0.6 }}>
          <AddPgModel  refresh={refresh} />
        </Box>
        <Tooltip title="refresh">
          <IconButton
            aria-label="refresh"
            // color="success"
            sx={{
              color: "#0F52BA",
            }}
            onClick={() => {
              refreshFunc(setQuery);
            }}
          >
            <CachedIcon className="refresh-purple" />
          </IconButton>
        </Tooltip>
      </Box>
      <div>
        <ApiPaginate
          apiEnd={ApiEndpoints.GET_PG_SCHEMA}
          columns={columns}
          apiData={apiData}
          tableStyle={CustomStyles}
          setApiData={setApiData}
          ExpandedComponent=""
          queryParam={query ? query : ""}
          returnRefetch={(ref) => {
            refresh = ref;
          }}
          paginateServer={false}
          paginate={false}
        />
      </div>
    </Box>
  );
};

export default AdminPgSchema;
